namespace Portico.Controllers {
    import Service = Portico.Decorators.Service;
    import Inject = Portico.Decorators.Inject;
    import pml = Portico.Models.Legacy;
    import ps = Portico.Services;
    import legacyEnrollmentModels = Portico.Services.Legacy.EnrollmentService.Models;

    @Service('app', 'testController')
    @Inject('LegacyEnrollmentService', 'LegacyCardService')
    export class TestController {
        public results: string;
        programId: number = 44;
        medBenProgramId: number = 59;
        constructor(private legacyEnrollmentService: ps.Legacy.EnrollmentService.ILegacyEnrollmentService
            , private legacyCardService: ps.Legacy.CardService.ILegacyCardService) { }

         //Patient search
        testLegacySearchPatients(): void {
            let searchModel = {
                "firstName": 'John',
                "lastName": null,
                "dateOfBirth": null,
                "city": 'Raleigh',
                "country": null,
                "state": 'NC',
                "postalCode": null,
                "memberNumber": null,
                "maxResults": 10,
                "skipRows": 0,
                "firstNameQueryType": Portico.Models.Legacy.FirstNameQueryTypeEnum.Contains,
                "lastNameQueryType": Portico.Models.Legacy.LastNameQueryTypeEnum.Contains,
                "email": null,
                "phone": null
            } as Models.Legacy.PatientSearchRequestModel;

            //let searchModel = {
            //	"maxResults": 1,
            //	"skipRows": 0,
            //	"firstNameQueryType": 0,
            //	"firstName": null,
            //	"lastNameQueryType": 0,
            //	"lastName": null,
            //	"dateOfBirth": null,
            //	"city": null,
            //	"state": null,
            //	"postalCode": null,
            //	"country": null,
            //	"memberNumber": "40847400809",
            //	"phone": null,
            //	"email": null
            //};


            this.legacyEnrollmentService.PatientSearchApi.post(this.programId, searchModel).then((response: pml.PatientSearchRecordModel[]) => {
                this.results = `Patient Search Result: ${response[0].firstName}  ${response[0].lastName} MemberNumber: ${response[0].memberNumber}`;
            }).catch((reason) => {
                alert('Failed: ' + reason);
            });
        }

        //basic enrollment
        testBasicEnrollmentApi() {

			let basicEnrollmentModel = {

				demographics: {
					personId: 0,
					firstName: '2Test3123',
					lastName: '2Tes1233t',
					gender: 'F',
					dateOfBirth: '07/12/1984',
					email: '',
					mobilePhone: '7144578172',
					homePhone: '7144578172',
					address1: '3516 E Jacaranda Ave',
					address2: '',
					city: 'Orange',
					state: 'CA',
					postalCode: '92867',
					memberNumber: '',
					country: 'US',
					communicationTypes: Portico.Models.Legacy.CommunicationTypesEnum.Email
				},

				survey: [
					{
						surveyId: 0,
						questionId: 10510,
						answerKey: 8113,
						answerText: 'Yes'
					},
					{
						surveyId: 0,
						questionId: 10511,
						answerKey: 8115,
						answerText: 'Yes'
					},
					{
						surveyId: 0,
						questionId: 10512,
						answerKey: 8117,
						answerText: 'Yes'
					}

				],

				clientIdentifiers: null


			} as Models.Legacy.EnrollmentRequestModel;

            this.legacyEnrollmentService.BasicEnrollmentApi.post(this.programId, basicEnrollmentModel).then((response: pml.EnrollmentResultModel) => {
                this.results = `Basic Enrollment Result: ${response.bin} ${response.memberNumber}`;
            }).catch((err) => {
                alert('Failed: ' + err);
            });

        }

        //basic enrollment pdf
        testBasicEnrollmentApiPdf() {

            let basicEnrollmentModel = {

                demographics: {
                    "personId": 0,
                    "firstName": "2Test3123",
                    "lastName": "2Tes1233t",
                    "gender": "F",
                    "dateOfBirth": "07/12/1984",
                    "email": "",
                    "mobilePhone": "7144578172",
                    "homePhone": "7144578172",
                    "address1": "3516 E Jacaranda Ave",
                    "address2": "",
                    "city": "Orange",
                    "state": "CA",
                    "postalCode": "92867",
                    "memberNumber": "",
					"country": "US",
					"communicationTypes": Portico.Models.Legacy.CommunicationTypesEnum.Email
                },

                survey: [
                    {
                        "surveyId": 0,
                        "questionId": 10510,
                        "answerKey": 8113,
                        "answerText": "Yes"
                    },
                    {
                        "surveyId": 0,
                        "questionId": 10511,
                        "answerKey": 8115,
                        "answerText": "Yes"
                    },
                    {
                        "surveyId": 0,
                        "questionId": 10512,
                        "answerKey": 8117,
                        "answerText": "Yes"
                    },

                ]


            } as Models.Legacy.EnrollmentRequestModel
            this.legacyEnrollmentService.BasicEnrollmentWithPdfApi.post(this.programId, basicEnrollmentModel).then((response: pml.EnrollmentWithPdfResultModel) => {
                this.results = `Basic Enrollment Result: ${response.bin} ${response.memberNumber}  Pdf: ${response.base64PdfFile} ` ;
            }).catch((err) => {
                alert('Failed: ' + err);
            });

        }

        testEnrollment() {
            let enrollmentModel = {

                demographics: {
                    "personId": 0,
                    "firstName": "2Test3123",
                    "lastName": "2Tes1233t",
                    "gender": "F",
                    "dateOfBirth": "07/12/1984",
                    "email": "",
                    "mobilePhone": "7144578172",
                    "homePhone": "7144578172",
                    "address1": "3516 E Jacaranda Ave",
                    "address2": "",
                    "city": "Orange",
                    "state": "CA",
                    "postalCode": "92867",
                    "memberNumber": "",
					"country": "US",
					"communicationTypes": Portico.Models.Legacy.CommunicationTypesEnum.Email
                },

                survey: [
                    {
                        "surveyId": 0,
                        "questionId": 10510,
                        "answerKey": 8113,
                        "answerText": "Yes"
                    },
                    {
                        "surveyId": 0,
                        "questionId": 10511,
                        "answerKey": 8115,
                        "answerText": "Yes"
                    },
                    {
                        "surveyId": 0,
                        "questionId": 10512,
                        "answerKey": 8117,
                        "answerText": "Yes"
                    },
                ],
                clientIdentifiers: {
                    "sourceId": "",
                    "alternateId": "",
                    "alternateIdType": "ThirdPartyID"
                },
                insuranceVerification: {
                    "insuranceType": 1,
                    "payerName": "P",
                    "payerPhone": "9999999998",
                    "bin": "B",
                    "pcn": "",
                    "payerMedicalId": "G"
                }


            } as Models.Legacy.EnrollmentInsVerRequestModel

            this.legacyEnrollmentService.EnrollmentApi.post(this.programId, enrollmentModel).then((response: pml.EnrollmentResultModel) => {
                this.results =
                    `Enrollment Result: ${response.memberNumber}  Benefit Amount: ${response.totalBenefitAmount} Remaining Beneift: ${response.remainingBenefitAmount}`;
            }).catch((err) => {
                alert('Failed: ' + err);
            });
        }

        testEnrollmentUpdate() {
            let enrollmentModel = {

                demographics: {
                    "personId": 0,
                    "firstName": "2Test3123",
                    "lastName": "2Tes1233t",
                    "gender": "F",
                    "dateOfBirth": "07/12/1984",
                    "email": "",
                    "mobilePhone": "7144578172",
                    "homePhone": "7144578172",
                    "address1": "3516 E Jacaranda Ave",
                    "address2": "",
                    "city": "Orange",
                    "state": "CA",
                    "postalCode": "92867",
                    "memberNumber": "39871588603",
					"country": "US",
					"communicationTypes": Portico.Models.Legacy.CommunicationTypesEnum.Email
                },

                clientIdentifiers: {
                    "sourceId": "",
                    "alternateId": "",
                    "alternateIdType": "ThirdPartyID"
                }


            } as Models.Legacy.EnrollmentUpdateRequestModel

            this.legacyEnrollmentService.EnrollmentUpdateApi.put(this.programId, enrollmentModel).then((response: pml.EnrollmentResultModel) => {
                this.results =
                    `Enrollment Update Result: ${response.memberNumber}`;
            }).catch((err) => {
                alert('Failed: ' + err);
            });
        }

        //medBenefitEnrollment() {

        //    let enrollmentModel = {
        //        demographics: {
        //            "firstName": "2Test3123",
        //            "lastName": "2Tes1233t",
        //            "gender": "F",
        //            "dateOfBirth": "07/12/2004",
        //            "email": "",
        //            "phoneNumbers": [
        //                {
        //                    "phoneNumberId": 0,
        //                    "countryCode": "1",
        //                    "areaCode": "919",
        //                    "number": "5550510",
        //                    "primaryPhoneNumber": true,
        //                    "phoneType": 0,
        //                    "phoneTypeDescription": null,
        //                    "extension": null
        //                }],
        //            "address1": "3516 E Jacaranda Ave",
        //            "address2": "",
        //            "city": "Orange",
        //            "state": "CA",
        //            "postalCode": "92867",
        //            "memberNumber": "",
        //            "country": "US",
        //            "communicationType": Models.Legacy.CommunicationTypeEnum.Email,
        //            "paymentType": Models.Legacy.PaymentTypeEnum.NUMBER_0
        //        },
        //        clientIdentifiers: {
        //            "sourceId": Models.Legacy.SourceIdEnum.NUMBER_5,
        //            "alternateId": "",
        //            "alternateIdType": "ThirdPartyID",
        //            "prescriberId": "5",
        //            "prescriberCommunicationType": Models.Legacy.PrescriberCommunicationTypeEnum.Email,
        //            "prescriberCommunicationOption": Models.Legacy.PrescriberCommunicationOptionEnum.NUMBER_0,
        //            "sites": [
        //                {
        //                    "siteId": "8",
        //                    "siteType": Models.Legacy.SiteTypeEnum.NUMBER_1,
        //                    "siteCommunicationType": Models.Legacy.SiteCommunicationTypeEnum.NUMBER_0,
        //                    "siteCommunicationOption": Models.Legacy.SiteCommunicationOptionEnum.NUMBER_0
        //                }
        //            ]
        //            },
        //        guardianInfo: {
        //            "personId": null,
        //            "namePrefix": null,
        //            "firstName": "Some",
        //            "middleName": null,
        //            "lastName": "Guardian",
        //            "nameSuffix": null,
        //            "dateOfBirth": "07/12/1984",
        //            "relationship": 0,
        //            "primaryPhoneNumber": {
        //                "phoneNumberId": 0,
        //                "countryCode": "1",
        //                "areaCode": "919",
        //                "number": "5550511",
        //                "primaryPhoneNumber": true,
        //                "phoneType": 0,
        //                "phoneTypeDescription": null,
        //                "extension": null
        //            }
        //        },
        //        insuranceVerification: null,
        //        survey: [{
        //                "surveyId": 0,
        //                "questionId": 10510,
        //                "answerKey": 8113,
        //                "answerText": "Yes"
        //            },
        //            {
        //                    "surveyId": 0,
        //                "questionId": 10511,
        //                "answerKey": 8115,
        //                "answerText": "Yes"
        //            },
        //            {
        //                    "surveyId": 0,
        //                "questionId": 10512,
        //                "answerKey": 8117,
        //                "answerText": "Yes"
        //            },
        //        ]
        //    } as Models.Legacy.MedBenEnrollmentRequestModel

        //    this.legacyEnrollmentService.MedBenefitEnrollmentApi.medBenefitEnrollmentPost(this.medBenProgramId, enrollmentModel)
        //        .then((response: pml.MedBenEnrollmentResultModel) => {
        //            this.results = `MedbenefitEnrollment Result: MemberNumber: ${response.memberNumber} ActivationDate:${response.cardActivationDate}`

        //        }).catch((err) => {
        //            alert('Failed: ' + err);
        //        });
        //}

        //medBenefitEnrollmentOptOut() {

        //    let enrollmentModel = {
        //        "memberNumber": "40847094309",
        //        "patientId": "x4qfwG0ee0x06dg8YOGNkg~~",
        //        "enrollmentId": "53qfwG0ee0x06dg8YOGNkg~~"

        //    } as Models.Legacy.MedBenOptOutRequestModel

        //    this.legacyEnrollmentService.MedBenefitEnrollmentOptOutApi.medBenefitEnrollmentOptOutPost(this.medBenProgramId, enrollmentModel)
        //        .then((response: never) => {
        //            this.results = `MedBenefitEnrollmentOptOut Result: ${response}`;
        //        }).catch((err) => {
        //            alert('Failed: ' + err);
        //        });
        //}


        //medBenefitEnrollmentUpdateApi() {

        //    let enrollmentModel = {
        //        demographics: {
        //            "firstName": "2Test3123",
        //            "lastName": "2Tes1233t",
        //            "gender": "F",
        //            "dateOfBirth": "07/12/2004",
        //            "email": "",
        //            "phoneNumbers": [
        //                {
        //                    "phoneNumberId": 0,
        //                    "countryCode": "1",
        //                    "areaCode": "919",
        //                    "number": "5550510",
        //                    "primaryPhoneNumber": true,
        //                    "phoneType": 0,
        //                    "phoneTypeDescription": null,
        //                    "extension": null
        //                }],
        //            "address1": "3516 E Jacaranda Ave",
        //            "address2": "",
        //            "city": "Orange",
        //            "state": "CA",
        //            "postalCode": "92867",
        //            "memberNumber": "12345678910",
        //            "country": "US",
        //            "communicationType": Models.Legacy.CommunicationTypeEnum.Email,
        //            "paymentType": Models.Legacy.PaymentTypeEnum.NUMBER_0
        //        },
        //        clientIdentifiers: {
        //            "sourceId": Models.Legacy.SourceIdEnum.NUMBER_5,
        //            "alternateId": "",
        //            "alternateIdType": "ThirdPartyID",
        //            "prescriberId": "5",
        //            "prescriberCommunicationType": Models.Legacy.PrescriberCommunicationTypeEnum.Email,
        //            "prescriberCommunicationOption": Models.Legacy.PrescriberCommunicationOptionEnum.NUMBER_0,
        //            "sites": [
        //                {
        //                    "siteId": "8",
        //                    "siteType": Models.Legacy.SiteTypeEnum.NUMBER_1,
        //                    "siteCommunicationType": Models.Legacy.SiteCommunicationTypeEnum.NUMBER_0,
        //                    "siteCommunicationOption": Models.Legacy.SiteCommunicationOptionEnum.NUMBER_0
        //                }
        //            ]
        //        },
        //        guardianInfo: {
        //            "personId": null,
        //            "namePrefix": null,
        //            "firstName": "Some",
        //            "middleName": null,
        //            "lastName": "Guardian",
        //            "nameSuffix": null,
        //            "dateOfBirth": "07/12/1984",
        //            "relationship": 0,
        //            "primaryPhoneNumber": {
        //                "phoneNumberId": 0,
        //                "countryCode": "1",
        //                "areaCode": "919",
        //                "number": "5550511",
        //                "primaryPhoneNumber": true,
        //                "phoneType": 0,
        //                "phoneTypeDescription": null,
        //                "extension": null
        //            }
        //        },
        //        insuranceVerification: null
        //    } as Models.Legacy.MedBenEnrollmentUpdateRequestModel

        //    this.legacyEnrollmentService.MedBenefitEnrollmentUpdateApi.medBenefitEnrollmentUpdatePut(this.medBenProgramId, enrollmentModel)
        //        .then((response: pml.MedBenEnrollmentResultModel) => {
        //            this.results =
        //                `MedBenefitEnrollment Update Result: MemberNumber: ${response.memberNumber} ActivationDate: ${response.cardActivationDate}`;
        //        }).catch((err) => {
        //            alert('Failed: ' + err);
        //        });
        //}


        //medBenefitPatientLookup() {
        //    let patientLookup = {
        //        "firstName": "TEST",
        //        "lastName": "LASTNAME",
        //        "dateOfBirth": "03/01/1995",
        //        "postalCode": "27615-1234",
        //        "gender": "m"
        //    } as Models.Legacy.PatientLookupRequestModel

        //    this.legacyEnrollmentService.MedBenefitPatientLookupApi.medBenefitPatientLookupPost(this.medBenProgramId, patientLookup)
        //        .then((response: pml.PatientLookupResultModel) => {
        //            this.results = `MedBenefit Patient Lookup:  MemberNumber: ${response.memberNumber} PatientId: ${response.patientId} Enrollment: ${response.enrollments[0].enrollmentId}`;
        //        }).catch((err) => {
        //            alert('Failed: ' + err);
        //        });
        //}

        //medBenefitPatientSearch() {

        //    let patientSearch = {
        //        "firstName": "TEST",
        //        "lastName": null,
        //        "dateOfBirth": null,
        //        "city": null,
        //        "state": null,
        //        "postalCode": null,
        //        "country": null,
        //        "memberNumber": null,
        //        "gender": "m",
        //        "enrollmentId": null,
        //        "patientId": null
        //    } as Models.Legacy.MedBenPatientSearchRequestModel

        //    this.legacyEnrollmentService.MedBenefitPatientSearchApi.medBenefitPatientSearchPost(this.medBenProgramId, patientSearch)
        //        .then((response: pml.MedBenPatientSearchResultModel) => {
        //            this.results =
        //                `MedBenefit Patient Search: First Name: ${response.demographics.firstName} Last Name: ${response.demographics.lastName} Enrollment: ${response.enrollments[0].enrollmentId}`;

        //        }).catch((err) => {
        //            alert('Failed: ' + err);
        //        });
        //}

        //medBenefitPrescriberUpsert(update: boolean) {
        //    let medBenefitPrescriberCreate = {
        //        "firstName": "Bob",
        //        "lastName": "Jones",
        //        "phoneNumber": {
        //            "phoneNumberId": 0,
        //            "countryCode": "1",
        //            "areaCode": "919",
        //            "number": "5550511",
        //            "primaryPhoneNumber": true,
        //            "phoneType": 0,
        //            "phoneTypeDescription": null,
        //            "extension": null
        //        },
        //        "address1": "3516 E Jacaranda Ave",
        //        "address2": "",
        //        "city": "Orange",
        //        "country": "US",
        //        "state": "CA",
        //        "postalCode": "92867"

        //    } as Models.Legacy.CreatePrescriberRequestModel

        //    let medBenefitPrescriberUpdate = {
        //        "prescriberId": "5",
        //        "firstName": "Bob",
        //        "lastName": "Jones",
        //        "phoneNumber": {
        //            "phoneNumberId": 0,
        //            "countryCode": "1",
        //            "areaCode": "919",
        //            "number": "5550511",
        //            "primaryPhoneNumber": true,
        //            "phoneType": 0,
        //            "phoneTypeDescription": null,
        //            "extension": null
        //        },
        //        "address1": "3516 E Jacaranda Ave",
        //        "address2": "",
        //        "city": "Orange",
        //        "country": "US",
        //        "state": "CA",
        //        "postalCode": "92867"

        //    } as  Models.Legacy.UpdatePrescriberRequestModel
        //    if (!update) {

        //        this.legacyEnrollmentService.MedBenefitPrescriberApi.medBenefitPrescriberPut(this.medBenProgramId, medBenefitPrescriberUpdate)
        //            .then((response: pml.CreatePrescriberResultModel) => {
        //                this.results = `Med benefit Create Prescriber: ${response.firstName}  ${response.firstName}  PrescriberId: ${response.prescriberId}`
        //            }).catch((err) => {
        //                alert('Failed: ' + err);
        //            });
        //    }
        //    else {
        //        this.legacyEnrollmentService.MedBenefitPrescriberApi.medBenefitPrescriberPost(this.medBenProgramId, medBenefitPrescriberCreate)
        //            .then((response: pml.CreatePrescriberResultModel) => {
        //                this.results = `Med benefit Update Prescriber: ${response.firstName}  ${response.firstName}  PrescriberId: ${response.prescriberId}`
        //            }).catch((err) => {
        //                alert('Failed: ' + err);
        //            });
        //    }
        //}

        //medBenefitSiteUpsert(update: boolean) {
        //    let medBenefitSiteCreate = {
        //        "siteVerified": true,
        //        "taxIdCaptured": true,
        //        "name": "SomeSite",
        //        "phoneNumber": {
        //            "phoneNumberId": 0,
        //            "countryCode": "1",
        //            "areaCode": "919",
        //            "number": "5550511",
        //            "primaryPhoneNumber": true,
        //            "phoneType": 0,
        //            "phoneTypeDescription": null,
        //            "extension": null
        //        },
        //        "address1": "3516 E Jacaranda Ave",
        //        "address2": "",
        //        "city": "Orange",
        //        "country": "US",
        //        "state": "CA",
        //        "postalCode": "92867"
        //    } as Models.Legacy.CreateSiteRequestModel

        //    let medBenefitSiteUpdate = {
        //        "siteId": "8",
        //        "siteVerified": true,
        //        "taxIdCaptured": true,
        //        "name": "SomeSite",
        //        "phoneNumber": {
        //            "phoneNumberId": 0,
        //            "countryCode": "1",
        //            "areaCode": "919",
        //            "number": "5550511",
        //            "primaryPhoneNumber": true,
        //            "phoneType": 0,
        //            "phoneTypeDescription": null,
        //            "extension": null
        //        },
        //        "address1": "3516 E Jacaranda Ave",
        //        "address2": "",
        //        "city": "Orange",
        //        "country": "US",
        //        "state": "CA",
        //        "postalCode": "92867"
        //    } as Models.Legacy.UpdateSiteRequestModel

        //    if (!update) {
        //        this.legacyEnrollmentService.MedBenefitSiteApi.medBenefitSitePut(this.medBenProgramId, medBenefitSiteUpdate)
        //            .then((response: pml.CreateSiteResultModel) => {
        //                this.results = `Med benefit Create Site: SiteId: ${response.siteId} UpdateDate: ${response.lastUpdateDate}`;

        //            }).catch((err) => {
        //                alert('Failed: ' + err);
        //            });
        //    }
        //    else {
        //        this.legacyEnrollmentService.MedBenefitSiteApi.medBenefitSitePost(this.medBenProgramId, medBenefitSiteCreate)
        //            .then((response: pml.CreateSiteResultModel) => {
        //                this.results = `Med benefit Create Site: SiteId: ${response.siteId} UpdateDate: ${response.lastUpdateDate}`;

        //            }).catch((err) => {
        //                alert('Failed: ' + err);
        //            });
        //    }
        //}

        //resendCorrespondence() {
        //    let resendCorrespondenceModel = {
        //        "memberNumber": "40847094309",
        //        "orderReferenceNumber": "34964"
        //    } as Models.Legacy.ResendCorrespondenceRequestModel

        //    this.legacyEnrollmentService.ResendCorrespondenceApi.resendCorrespondencePost(this.programId, resendCorrespondenceModel)
        //        .then((response: pml.ResendCorrespondenceResultModel) => {
        //            this.results =
        //                `Resend Correspondence Result: MN: ${response.memberNumber} Old Order Reference number: ${response.oldOrderReferenceNumber}, New Order Reference number: ${response.newOrderReferenceNumber}`
        //        }).catch((err) => {
        //            alert('Failed: ' + err);
        //        });
        //}

        verifySurveyAnswer() {
            let survey = {
                "surveyId": 0,
                "questionId": 10510,
                "answerKey": 8113,
                "answerText": "Yes"
            } as Models.Legacy.VerifySurveyEntryRequestModel

            this.legacyEnrollmentService.VerifySurveyAnswerApi.post(this.programId, survey)
                .then((response: pml.VerifySurveyEntryResultModel) => {
                    this.results = `Verify Survey Answer Result: IsEligible: ${response.isEligible}`;
                }).catch((err) => {
                    alert('Failed: ' + err);
                });
        }

        createCard() {
            this.legacyCardService.CreateCardApi.post(this.programId, 1).then((response: pml.CardCreatedModel[]) => {
                this.results = `Create Card Result: MemberNumber: ${response[0].memberNumber} Activation Date: ${response[0].cardActivationDate}`;
            }).catch((err) => {
                alert('Failed: ' + err);
            });
        }

        //medBenDebitCardActivation() {
        //    let debitCard = {
        //        "memberNumber": "12345678910",
        //        "patientId": "x4qfwG0ee0x06dg8YOGNkg~~",
        //        "cardLastFourDigits": "3454",
        //        "dateOfBirth": "07/12/2004",
        //        "expirationDate": "02/18"
        //    } as Models.Legacy.CardActivationRequestModel

        //    this.legacyCardService.MedBenefitDebitCardActivationApi.medBenefitDebitCardActivationPost(this.medBenProgramId, debitCard)
        //        .then((response: pml.MedBenStandardResultModel) => {
        //            this.results = `Debit Card Activation Result: MemberNumber: ${response.memberNumber} Activation Date: ${response.cardActivationDate}`;
        //        }).catch((err) => {
        //            alert('Failed: ' + err);
        //        });
        //}

        //medBenDebitCardStatus() {
        //    this.legacyCardService.MedBenefitDebitCardStatusApi.medBenefitDebitCardStatusGet(this.medBenProgramId, '40847094309', 'x4qfwG0ee0x06dg8YOGNkg%7E%7E')
        //        .then((response: pml.CardStatusResultModel) => {
        //            this.results = `Debit Card Status: ${response.memberNumber} Card Activation Date: ${response.cardActivationDate} Card balance: ${response.cardBalance}`;

        //        })
        //}

        //medBenReplaceCard() {
        //    let replaceCard = {
        //        "memberNumber": "40847094309",
        //        "patientId": "x4qfwG0ee0x06dg8YOGNkg~~"
        //    } as Models.Legacy.MedBenCardReplaceRequestModel

        //    this.legacyCardService.MedBenefitReplaceCardApi.medBenefitReplaceCardPost(this.medBenProgramId, replaceCard)
        //        .then((response: pml.MedBenCardReplaceResultModel) => {
        //            this.results = `Replace Card Result: MN: ${response.memberNumber} Ref#: ${response.orderReferenceNumber}`;

        //        }).catch((err) => {
        //            alert('Failed: ' + err);
        //        });
        //}

        memberNumberStatus() {
            this.legacyCardService.MemberNumberStatusApi.get(this.medBenProgramId, '40847094309')
                .then((response: pml.MemberNumberStatusResultModel) => {
                    this.results = `Member Number Status: MN: ${response.memberNumber}`

                }).catch((err) => {
                    alert('Failed: ' + err);
                });

        }

        replaceCard() {
            let replaceCardModel = {
                "memberNumber": "40847094309"
            } as Models.Legacy.ReplaceCardRequestModel

            this.legacyCardService.ReplaceCardApi.post(this.programId, replaceCardModel)
                .then((response: pml.ReplaceCardResultModel) => {
                    this.results = `Replace Card Result: MN: ${response.memberNumber} Ref#: ${response.orderReferenceNumber}`
                }).catch((err) => {
                    alert('Failed: ' + err);
                });
        }
        terminateCard(){
            let terminateCard = {
                "memberNumber": "60077945909",
                "terminateDate": "12/01/2017"

            } as Models.Legacy.TerminateCardRequestModel

            this.legacyCardService.TerminateCardApi.put(this.programId, terminateCard)
                .then((response: never) => {
                    this.results = 'Terminate Card Result: Card Terminated';
                }).catch((err) => {
                    alert('Failed: ' + err);
                });
        }
    }
}